import CombineReducer from "./Reducers/CombineReducers";
import { createStore, applyMiddleware, Store } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from '@redux-devtools/extension';
const store = createStore(CombineReducer, composeWithDevTools(applyMiddleware(thunk)))
export default store;